'use client';

import { Suspense } from 'react';
import withProtectedRoute from '../hoc/withProtectedRoute';

interface ProtectedLayoutProps {
  children: React.ReactNode;
}

function ProtectedLayoutContent({ children }: ProtectedLayoutProps) {
  return <>{children}</>;
}

const Protected = withProtectedRoute(ProtectedLayoutContent);

export default function ProtectedLayout({ children }: ProtectedLayoutProps) {
  return (
    <Suspense>
      <Protected>{children}</Protected>
    </Suspense>
  );
}
